<h3>Filter by Company/Station</h3>

<h4>Company</h4>
<mat-form-field>
  <mat-label>Select company</mat-label>
  <mat-select>
    <mat-option *ngFor='let company of companies' [value]='company.value'>
      {{ company.viewValue }}
    </mat-option>
  </mat-select>
</mat-form-field>

<h4>Station</h4>
<mat-form-field>
  <mat-label>Select station</mat-label>
  <mat-select>
    <mat-option *ngFor='let station of stations' [value]='station.value'>
      {{ station.value }}
    </mat-option>
  </mat-select>
</mat-form-field>
